(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oneup-trust"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeTrustSection = (trustSection) => {
      if (
        !trustSection ||
        trustSection.dataset.initialized === "true"
      ) {
        return;
      }

      trustSection.dataset.initialized = "true";

      const cards = trustSection.querySelectorAll(
        ".oneup-trust__card"
      );

      const reduceMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;

      if (
        reduceMotion ||
        !("IntersectionObserver" in window)
      ) {
        cards.forEach((card) => {
          card.classList.add("show");
        });

        return;
      }

      trustSection.classList.add("is-animated");

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }

            const card = entry.target;

            card.classList.add("show");

            const number = card.querySelector(
              '[data-animate-count="true"]'
            );

            if (number) {
              const rawTarget =
                number.dataset.countTarget;

              const target = Number(rawTarget);

              const decimals = rawTarget.includes(".")
                ? rawTarget.split(".")[1].length
                : 0;

              const duration = 1600;

              let startTime;

              const formatValue = (value) => {
                return value.toLocaleString(
                  undefined,
                  {
                    minimumFractionDigits: decimals,
                    maximumFractionDigits: decimals
                  }
                );
              };

              const animateCount = (timestamp) => {
                if (startTime === undefined) {
                  startTime = timestamp;
                }

                const progress = Math.min(
                  (timestamp - startTime) / duration,
                  1
                );

                const easedProgress =
                  1 - Math.pow(1 - progress, 3);

                const value =
                  decimals > 0
                    ? easedProgress * target
                    : Math.floor(
                        easedProgress * target
                      );

                number.textContent =
                  formatValue(value);

                if (progress < 1) {
                  window.requestAnimationFrame(
                    animateCount
                  );
                } else {
                  number.textContent =
                    formatValue(target);
                }
              };

              number.textContent = formatValue(0);

              window.requestAnimationFrame(
                animateCount
              );
            }

            observer.unobserve(card);
          });
        },
        {
          threshold: 0.25
        }
      );

      cards.forEach((card, index) => {
        card.style.transitionDelay =
          `${index * 0.12}s`;

        observer.observe(card);
      });
    };

    const initializeAllTrustSections = (
      root = document
    ) => {
      root
        .querySelectorAll("[data-oneup-trust]")
        .forEach(initializeTrustSection);
    };

    if (document.readyState === "loading") {
      document.addEventListener(
        "DOMContentLoaded",
        () => initializeAllTrustSections()
      );
    } else {
      initializeAllTrustSections();
    }

    document.addEventListener(
      "shopify:section:load",
      (event) => {
        initializeAllTrustSections(event.target);
      }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
